import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import 'rxjs/add/operator/map';
import { HttpClientService } from './../http-client/http-client.service';
import { AddEmployeeDto } from '../../models/employee/add-employee-dto';
import { Service } from '../service';

@Injectable()
export class EmployeeService extends Service {

    public employees: any[];
    public employeesObject: any;

    constructor(
        private http: HttpClientService
    ) {
        super();
        this.employees = [];
        this.employeesObject = {};
    }

    public getAll(): Observable<any[]> {
        if (!!this.employees && this.employees.length > 0) {
            return Observable.create((observer: Subscriber<any[]>) => {
                observer.next(this.employees);
                observer.complete();
            });
        }
        const url = 'employees/all';
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.employees = r.Result;
                console.log(this.employees);
                this.employeesObject = this.employees.reduce((result, s) => {
                    result[String(s.Id)] = result[String(s.Id)] || {};
                    result[String(s.Id)] = s;
                    return result;
                }, {});
            } else {
                console.error('employeeservice > getAll > response', r);
            }
            return this.employees;
        }).catch(this.handleError);
    }

    public getAllTeachers(): Observable<any[]> {
        if (!!this.employees && this.employees.length > 0) {
            return Observable.create((observer: Subscriber<any[]>) => {
                observer.next(this.employees.filter(e => e.JobTitles.map(f => f.JobTitleId).indexOf(4) !== -1));
                observer.complete();
            });
        }
        const url = 'employees/all';
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.employees = r.Result;
                console.log(this.employees);
                this.employeesObject = this.employees.reduce((result, s) => {
                    result[String(s.Id)] = result[String(s.Id)] || {};
                    result[String(s.Id)] = s;
                    return result;
                }, {});
            } else {
                console.error('employeeservice > getAll > response', r);
            }
            return this.employees.filter(e => e.JobTitles.map(f => f.JobTitleId).indexOf(4) !== -1);
        }).catch(this.handleError);
    }

    public getViceDirector(shiftId: number): Observable<any[]> {
        if (!!this.employees && this.employees.length > 0) {
            console.log("************************>LOCAL");
            return Observable.create((observer: Subscriber<any[]>) => {
                //observer.next(this.employees.filter(e => e.JobTitles.map(f => f.JobTitleId).indexOf(2) !== -1).filter(e => e.JobTitles.map(f => f.ShiftId).indexOf(shiftId) !== -1));
                observer.next(this.employees.filter(e => e.JobTitles.map(f => f.JobTitleId).indexOf(2) !== -1));
                observer.complete();
            });
        }
        const url = 'employees/all';
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.employees = r.Result;
                console.log(this.employees);
                this.employeesObject = this.employees.reduce((result, s) => {
                    result[String(s.Id)] = result[String(s.Id)] || {};
                    result[String(s.Id)] = s;
                    return result;
                }, {});
            } else {
                console.error('employeeservice > getAll > response', r);
            }
            //return this.employees.filter(e => e.JobTitles.map(f => f.JobTitleId).indexOf(2) !== -1).filter(ex => ex.ShiftId == shiftId);
            //return this.employees.filter(e => e.JobTitles.map(f => f.JobTitleId).indexOf(2) !== -1).filter(e => e.JobTitles.map(f => f.ShiftId).indexOf(shiftId) !== -1);
            return this.employees.filter(e => e.JobTitles.map(f => f.JobTitleId).indexOf(2) !== -1);
        }).catch(this.handleError);
    }

    public add(addEmployeeDto: AddEmployeeDto) {
        const url = 'employees/add';
        return this.http.post(url, addEmployeeDto).map(response => response.json())
            .catch(this.handleError);
    }

    public edit(addEmployeeDto: AddEmployeeDto) {
        const url = 'employees/add';
        return this.http.post(url, addEmployeeDto).map(response => response.json())
            .catch(this.handleError);
    }

    public delete(id: string) {
        const url: string = 'employees/delete/' + id;
        return this.http.delete(url).map(response => response.json())
            .catch(this.handleError);
    }

    public getMails(shifts: number[], jobTitles: number[]): Observable<string> {
        const url = 'employees/mail/' + shifts + "/" + jobTitles;
        return this.http.get(url).map(response => {
            const r = response.json();
            let mailsList = "";
            if (r.ResultCode === 1) {
                r.Result.forEach(e =>
                    mailsList = mailsList + e.Email + ","
                );
                return mailsList.substring(0, mailsList.length - 1);
            } else {
                console.error('employeeservice > getAll > response', r);
            }
            //return this.employees.filter(e => e.JobTitles.map(f => f.JobTitleId).indexOf(2) !== -1).filter(ex => ex.ShiftId == shiftId);
            //return this.employees.filter(e => e.JobTitles.map(f => f.JobTitleId).indexOf(2) !== -1).filter(e => e.JobTitles.map(f => f.ShiftId).indexOf(shiftId) !== -1);
            return this.employees.filter(e => e.JobTitles.map(f => f.JobTitleId).indexOf(2) !== -1);
        }).catch(this.handleError);
    }

    public getByDocumentNumber(documentNumber: string): Observable<any> {
        const url = 'employees/byDocumentNumber/' + documentNumber;
        return this.http.get(url).map(response => {
            const r = response.json();
            let tutor;
            if (r.ResultCode === 1) {
                tutor = r.Result;
            } else {
                console.error('TutorService > getById > response', r);
            }
            return tutor;
        }).catch(this.handleError);
    }

    public getByEmployeeId(employeeId: string): Observable<any> {
        const url = 'employees/get/' + employeeId;
        return this.http.get(url).map(response => {
            const r = response.json();
            let tutor;
            if (r.ResultCode === 1) {
                tutor = r.Result;
            } else {
                console.error('TutorService > getByEmployeeId > response', r);
            }
            return tutor;
        }).catch(this.handleError);
    }

    public getAssignments(employeeId: string, schoolYearId: number): Observable<any[]> {
        const url = `employees/assignments/${employeeId}/${schoolYearId}`;
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                return r.Result;
            } else {
                console.error('EmployeeService > getAssignments > error', r);
                return [];
            }
        }).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/employee/employee.service.ts